// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"t5-z"};